import React from 'react'
import { Route, Redirect } from 'react-router-dom'


const PrivateRouteScreen = ({componentAdmin: ComponentAdmin, componentUm: ComponentUm, login, ...props}) => {
  return (
  <Route
    {...props}

    render={props => {
      if(login.id && login.type==='admin')
        return <ComponentAdmin {...props} />
      else if(login.id && login.type==='promotion_department')
          return <ComponentUm {...props} />
      else
        return <Redirect
                  to={{
                    pathname: "/login",
                    state: { from: props.location, logout: true }
                  }}
                />
    
  }}
    

  />
  )
}

export default PrivateRouteScreen



// WEBPACK FOOTER //
// ./src/screens/PrivateRouteScreen.js